import { localeStore } from '@/shared/i18n/locale-store';
import type { Locale } from '@/shared/i18n/locales';
import { translate } from '@/shared/i18n/translate';
import { formatTimestamp } from './format-timestamp';

/** "just now", "5 min ago", "3 h ago", then the date and time, for a UTC ISO timestamp. */
export function formatAgo(
  iso: string,
  now: number = Date.now(),
  locale: Locale = localeStore.read(),
): string {
  const minutes = Math.floor((now - new Date(iso).getTime()) / 60_000);
  if (Number.isNaN(minutes)) return '—';
  if (minutes < 1) return translate(locale, 'just now');
  if (minutes < 60) return translate(locale, '{count} min ago', { count: minutes });
  if (minutes < 24 * 60) return translate(locale, '{count} h ago', { count: Math.floor(minutes / 60) });
  return formatTimestamp(iso, locale);
}
